import { all, takeLatest, put, call, select } from 'redux-saga/effects';

import {
  fetchMasterySuccess,
  fetchMasteryFailure,
  FETCH_MASTERY_DATA,
  fetchAssessmentListSuccess,
  fetchAssessmentListFailure,
  FETCH_ASSESSMENT_LIST_DATA,
  FETCH_DROP_DOWN_DATA,
  fetchDropDownDataSuccess,
  fetchDropDownDataFailure,
  getSelectedClassId,
  getSelectedSemesterId,
  getSelectedSubjectId,
  CHANGE_SEMESTER_INDEX,
  CHANGE_SUBJECT_INDEX,
  CHANGE_CLASS_INDEX,
  FETCH_ASSESSMENT_DETAIL_DATA,
  fetchAssessmentDetailDataSuccess,
  fetchAssessmentDetailDataFailure,
  FETCH_MASTERY_DETAIL_DATA,
  fetchMasteryDetailDataSuccess,
  fetchMasteryDetailDataFailure,
  FETCH_ASSESSMENT_PAGE_DATA,
  fetchAssessmentPageDataSuccess,
  fetchAssessmentPageDataFailure,
  FETCH_MASTERY_PAGE_DATA,
  fetchMasteryPageDataSuccess,
  fetchMasteryPageDataFailure,
  FETCH_STUDENT_LIST_DATA,
  fetchStudentListDataSuccess,
  fetchStudentListDataFailure,
  FETCH_STUDENT_PAGE_DATA,
  fetchStudentPageDataSuccess,
  fetchStudentPageDataFailure,
  FETCH_STUDENT_SCORE_PAGE_DATA,
  fetchStudentScoresPageData,
  fetchStudentScoresPageDataSuccess,
  fetchStudentScoresPageDataFailure,
  getCurrentPageName,
  fetchMasteryData,
  fetchAssessmentListData,
  fetchStudentListData,
  getCurrentStudentId,
} from '@blueberry/redux/tutorDashboard';
import { actions as errorActions } from '@blueberry/redux/error';
import { chagneSchoolSubject } from '@blueberry/redux/dashboard';
import { setStudentId } from '@blueberry/redux/scoreRecord';
import {
  fetchRecordCategoriesFlow,
  fetchScoreRecordListFlow,
} from '@blueberry/sagas/scoreRecord';

import {
  fetchDropDownData,
  fetchAssessmentList,
  fetchAssessmentDetail,
  fetchMasteryList,
  fetchMasteryDetail,
  fetchStudentList,
  // fetchScoreTypes,
} from '@blueberry/services/apis';

import {
  MATERY,
  ASSESSMENT,
  STUDENT,
  STUDENT_SCORE_RECORD,
} from '@blueberry/constants/dashboardRouting';

export function* fetchDropDownDataFlow() {
  try {
    const { school_classes: schoolClasses, semesters, subjects } = yield call(
      fetchDropDownData
    );

    yield put(
      fetchDropDownDataSuccess({
        schoolClasses,
        semesters,
        subjects,
      })
    );
  } catch (error) {
    yield put(errorActions.sendError(error));
    yield put(fetchDropDownDataFailure(error));
  }
}

function* fetchMasteryPageDataFlow() {
  try {
    yield call(fetchDropDownDataFlow);
    yield call(fetchMasteryDataFlow);
    yield put(fetchMasteryPageDataSuccess());
  } catch (error) {
    yield put(fetchMasteryPageDataFailure());
  }
}
function convertDecimal2Percentage(val = 0) {
  return Math.round(val * 100);
}

export function* fetchMasteryDataFlow() {
  try {
    const selectedClassId = yield select(getSelectedClassId);
    const selectedSemesterId = yield select(getSelectedSemesterId);
    const selectedSubjectId = yield select(getSelectedSubjectId);

    const { mastery_list: masteryList } = yield call(fetchMasteryList, {
      semesterId: selectedSemesterId,
      classId: selectedClassId,
      subjectId: selectedSubjectId,
    });

    const data = masteryList.map(topic => ({
      ...topic,
      concept_avg: convertDecimal2Percentage(topic.concept_avg),
      grade_concept_avg: convertDecimal2Percentage(topic.grade_concept_avg),
      subtopics: topic.subtopics.map(subtopic => ({
        ...subtopic,
        concept_avg: convertDecimal2Percentage(subtopic.concept_avg),
        grade_concept_avg: convertDecimal2Percentage(
          subtopic.grade_concept_avg
        ),
      })),
    }));

    yield put(fetchMasterySuccess(data));
  } catch (err) {
    yield put(errorActions.sendError(err));
    yield put(fetchMasteryFailure(err));
  }
}

function* fetchSubtopicDataFlow(action) {
  const { subtopicId, semesterId, classId } = action.payload;

  try {
    yield call(fetchDropDownDataFlow);
    const data = yield call(fetchMasteryDetail, {
      semesterId,
      classId,
      subtopicId,
    });

    yield put(fetchMasteryDetailDataSuccess(data));
  } catch (err) {
    yield put(errorActions.sendError(err));
    yield put(fetchMasteryDetailDataFailure(err));
  }
}

function* fetchAssessmentPageDataFlow() {
  try {
    yield call(fetchDropDownDataFlow);
    yield call(fetchAssessmentListDataFlow);
    yield put(fetchAssessmentPageDataSuccess());
  } catch (error) {
    yield put(fetchAssessmentPageDataFailure());
  }
}

export function* fetchAssessmentListDataFlow() {
  try {
    const selectedClassId = yield select(getSelectedClassId);
    const selectedSemesterId = yield select(getSelectedSemesterId);
    const selectedSubjectId = yield select(getSelectedSubjectId);

    const { assessments } = yield call(fetchAssessmentList, {
      semesterId: selectedSemesterId,
      classId: selectedClassId,
      subjectId: selectedSubjectId,
    });

    yield put(fetchAssessmentListSuccess(assessments));
  } catch (err) {
    yield put(errorActions.sendError(err));
    yield put(fetchAssessmentListFailure(err));
  }
}

function* fetchAssesmentDetailFlow(action) {
  const assessmentId = action.payload.assessmentId;

  try {
    const data = yield call(fetchAssessmentDetail, assessmentId);
    yield put(fetchAssessmentDetailDataSuccess(data));
  } catch (err) {
    yield put(errorActions.sendError(err));
    yield put(fetchAssessmentDetailDataFailure(err));
  }
}

function* fetchStudentListFlow() {
  const selectedClassId = yield select(getSelectedClassId);
  const selectedSemesterId = yield select(getSelectedSemesterId);
  try {
    const { students } = yield call(fetchStudentList, {
      semesterId: selectedSemesterId,
      classId: selectedClassId,
    });

    yield put(fetchStudentListDataSuccess(students));
  } catch (err) {
    yield put(errorActions.sendError(err));
    yield put(fetchStudentListDataFailure(err));
  }
}

function* fetchStudentPageDataFlow() {
  try {
    yield call(fetchDropDownDataFlow);
    yield call(fetchStudentListFlow);
    yield put(fetchStudentPageDataSuccess());
  } catch (error) {
    yield put(fetchStudentPageDataFailure());
  }
}

function* fetchStudentScorePageFlow(action) {
  try {
    // TODO refine the flow after APIs are done.
    yield call(fetchDropDownDataFlow);
    const { studentId, subjectId } = action.payload;
    yield put(chagneSchoolSubject(subjectId));
    yield put(setStudentId(studentId));

    // Using same score record flow with student at the moment.
    yield call(fetchRecordCategoriesFlow);
    yield call(fetchScoreRecordListFlow);

    yield put(fetchStudentScoresPageDataSuccess());
  } catch (error) {
    yield put(fetchStudentScoresPageDataFailure());
  }
}

function* updatePageDataFlow() {
  const currentPage = yield select(getCurrentPageName);

  if (currentPage === MATERY) yield put(fetchMasteryData());
  if (currentPage === ASSESSMENT) yield put(fetchAssessmentListData());
  if (currentPage === STUDENT) yield put(fetchStudentListData());
  if (currentPage === STUDENT_SCORE_RECORD) {
    const selectedSemesterId = yield select(getSelectedSemesterId);
    const selectedSubjectId = yield select(getSelectedSubjectId);
    const currentStudentId = yield select(getCurrentStudentId);
    yield put(
      fetchStudentScoresPageData(
        currentStudentId,
        selectedSemesterId,
        selectedSubjectId
      )
    );
  }
}

export default function*() {
  yield all([
    takeLatest(FETCH_DROP_DOWN_DATA, fetchDropDownDataFlow),
    takeLatest(FETCH_MASTERY_PAGE_DATA, fetchMasteryPageDataFlow),
    takeLatest(FETCH_MASTERY_DATA, fetchMasteryDataFlow),
    takeLatest(FETCH_MASTERY_DETAIL_DATA, fetchSubtopicDataFlow),
    takeLatest(FETCH_ASSESSMENT_PAGE_DATA, fetchAssessmentPageDataFlow),
    takeLatest(FETCH_ASSESSMENT_LIST_DATA, fetchAssessmentListDataFlow),
    takeLatest(CHANGE_SEMESTER_INDEX, updatePageDataFlow),
    takeLatest(CHANGE_SUBJECT_INDEX, updatePageDataFlow),
    takeLatest(CHANGE_CLASS_INDEX, updatePageDataFlow),
    takeLatest(FETCH_ASSESSMENT_DETAIL_DATA, fetchAssesmentDetailFlow),
    takeLatest(FETCH_STUDENT_LIST_DATA, fetchStudentListFlow),
    takeLatest(FETCH_STUDENT_PAGE_DATA, fetchStudentPageDataFlow),
    takeLatest(FETCH_STUDENT_SCORE_PAGE_DATA, fetchStudentScorePageFlow),
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/tutorDashboard.js